<script>
export default {
  props: {
    icon: {
      type: String,
      default: () => null,
    },
  },
};
</script>

<template>
  <div>
    <v-layout
      row
      align-center
    >
      <v-flex xs1>
        <v-icon color="#433D4E">
          {{ icon }}
        </v-icon>
      </v-flex>
      <v-flex
        xs11
        class="ml-2"
      >
        <slot />
      </v-flex>
    </v-layout>
  </div>
</template>

<style lang="scss" scoped>
</style>
